var lib_core = require("lib-core");

/**
 * @constructor
 */
var VersionsStateMachine = function (root, model, editorModel) {
    var self = this;
    this.root = root;

    this.editorModel = editorModel;
    this.model = model;

    lib_core.StateMachine.call(self);

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CREATE_VERSION_VERSIONSIDEBAR;
        },
        function(cEvent){
            self.createNewVersion(cEvent.data('description'));
        }
    );

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.TOGGLE_DRAFT_VERSIONSIDEBAR;
        },
        function(cEvent){
            self.model.draftVisible(!self.model.draftVisible());
        }
    );

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.SHOW_DRAFT_VERSIONSIDEBAR;
        },
        function(cEvent){
            if(self.model.sidebarModel) self.model.sidebarModel.show(true);
            self.model.draftVisible(true);
        }
    );

};

lib_core.inherit(VersionsStateMachine, lib_core.StateMachine);
module.exports = VersionsStateMachine;

VersionsStateMachine.prototype.createNewVersion = function(description) {
    var self = this;

    // NOTE we are ignoring the name parameter right now.
    
    if(self.model.sidebarModel) self.model.sidebarModel.show(true);
    self.model.busy(true);
    self.model.draftVisible(false);

    if(!self.root.data.isComplete()) {
        var err = new Error("Can't create a new version.");
        logError("Version State Machine", err, lib_core.logError.criticality.MAJOR, "This document does not meet the minimum requirements to be saved as a usable version.", true);
        self.model.busy(false);
        return Promise.reject();
    }

    var assetId = self.root.header["assetId"];
    var assetType = self.root.header["assetType"];
    var colabDoc = {
        "header": self.root.header,
        "body": self.root.jsonify()
    };
    delete colabDoc.header.version;
    colabDoc['undo'] = [];
    colabDoc['redo'] = [];

    var updatedVersion;    
    var name;

    return self.model.reloadVersions()
    .then(function(){
        name = self.model.asset().getNextVersionNumber();
    })
    .then(function(){
        return self.root.dataLoader.dataManager.createResourceVersion(assetType, assetId, name, description || "No description", colabDoc)
    })
    .then(function(updatedVersionInfo) {
        updatedVersion = updatedVersionInfo["version"];
        return self.model.reloadVersions();
    })
    .then(function() {
        self.model.busy(false);
        self.model.dataRoot.wasSaved();
        return updatedVersion;
    });
};
